import React from 'react';
import Grid from '@mui/material/Grid';
import { useFormik } from 'formik';

import MdtOnboardingStepWrapper from './components/MdtOnboardingStepWrapper';
import MdtOnboardingHelperText from './components/MdtOnboardingHelperText';
import { Typography } from '@mui/material';


export default function OnboardingIntroductionStep({ handleNext }) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    onSubmit: async () => {
      handleNext();
    },
  });

  return (
    <MdtOnboardingStepWrapper name="Introduction to Onboarding Process" formik={formik} backDisabled>
      <Grid item xs={12} sm={12}>
        <Typography>
          <p>Welcome to Medsym!</p>
          <p>This onboarding process is designed to verify your credentials and get you access to the Multi-Disciplinary Team functionality.</p>
          
          <p>You will go through several steps, each with specific requirements necessary for completion. During this process, you will need to provide specific documentation for address, identity, and other verifications. Once these steps are completed, we will verify your affiliation. After the completion of these processes, your application will be reviewed.</p>
          <p>Let&apos;s get started!</p>
        </Typography>
      </Grid>

      <MdtOnboardingHelperText />
    </MdtOnboardingStepWrapper>
  );
}
